import { drawing } from '@progress/kendo-drawing';
import { deepExtend } from '../utils/deep-extend.js';
import { Element } from './Element.js';
import { TRANSPARENT } from '../constants.js';
import { normalizeDrawingOptions, getColor } from './utils.js';

const defaultOptions = {
    stroke: {
        color: 'gray',
        width: 1
    },
    fill: {
        color: TRANSPARENT
    }
};
class VisualBase extends Element {
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        super(options);
        options = this.options;
        options.fill = normalizeDrawingOptions(options.fill);
        options.stroke = normalizeDrawingOptions(options.stroke);
    }
    fill(color, opacity) {
        this._fill({
            color: getColor(color),
            opacity: opacity
        });
    }
    stroke(color, width, opacity) {
        this._stroke({
            color: getColor(color),
            width: width,
            opacity: opacity
        });
    }
    redraw(options) {
        if (options) {
            const stroke = options.stroke;
            const fill = options.fill;
            if (stroke) {
                this._stroke(normalizeDrawingOptions(stroke));
            }
            if (fill) {
                this._fill(normalizeDrawingOptions(fill));
            }
            super.redraw(options);
        }
    }
    _hover(show) {
        const drawingElement = this.drawingElement;
        const options = this.options;
        const hover = options.hover;
        if (hover && hover.fill) {
            const fill = show ? normalizeDrawingOptions(hover.fill) : options.fill;
            drawingElement.fill(fill.color, fill.opacity);
        }
    }
    _stroke(strokeOptions) {
        const options = this.options;
        deepExtend(options, {
            stroke: strokeOptions
        });
        strokeOptions = options.stroke;
        let stroke = null;
        if (strokeOptions.width > 0) {
            stroke = {
                color: strokeOptions.color,
                width: strokeOptions.width,
                opacity: strokeOptions.opacity,
                dashType: strokeOptions.dashType
            };
        }
        this.drawingElement.options.set('stroke', stroke);
    }
    _fill(fillOptions) {
        const options = this.options;
        deepExtend(options, {
            fill: fillOptions || {}
        });
        const fill = options.fill;
        if (fill.gradient) {
            const gradient = fill.gradient;
            const GradientClass = (gradient.type === 'radial' ? drawing.RadialGradient : drawing.LinearGradient);
            this.drawingElement.fill(new GradientClass(gradient));
        }
        else {
            this.drawingElement.fill(fill.color, fill.opacity);
        }
    }
}

export { VisualBase };
